'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import DonationFormRequiredField from '@/donationPages/_dependencies/components/DonationFormRequiredField';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import FormInput from '@/form/FormInput';
function CompanyFields() {
  const $ = _c(5);
  const t = useTranslations("nextjs.donate.attributes");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["_company_donation"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [companyDonation] = useDonationFormValues(t0);
  if (!companyDonation) {
    return null;
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("company_name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <DonationFormRequiredField name="company_name" title={t1} as={FormInput} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export default CompanyFields;